import React from 'react';

import { unCamelCase } from './../../helpers/camelCase';
import { convertBoolean } from '../../helpers/convertBoolean';

import { Select, MenuItem } from '@material-ui/core';

const EditableSelect = ({ data, setData, labels, isStatus = false, isDeletedAt, isColorTheme }) => {
  return labels.map(label => {
    if (isDeletedAt) {
      return (
        <div key={label} className="MuiFormControl-root MuiTextField-root select-container">
          <span>{unCamelCase(label)}</span>
          <Select
            className="select-input"
            value={data[label]}
            onChange={e => {
              setData({ ...data, [label]: e.target.value });
            }}
          >
            <MenuItem value={null}>null</MenuItem>
          </Select>
        </div>
      );
    } else if (isStatus) {
      return (
        <div key={label} className="MuiFormControl-root MuiTextField-root select-container">
          <span>{unCamelCase(label)}</span>
          <Select
            className="select-input"
            value={data[label]}
            onChange={e => {
              setData({ ...data, [label]: e.target.value });
            }}
          >
            <MenuItem value={'pending'}>pending</MenuItem>
            <MenuItem value={'processing'}>processing</MenuItem>
            <MenuItem value={'failed'}>failed</MenuItem>
            <MenuItem value={'success'}>success</MenuItem>
            <MenuItem value={'canceled'}>canceled</MenuItem>
          </Select>
        </div>
      );
    } else if (isColorTheme) {
      return (
        <div key={label} className="MuiFormControl-root MuiTextField-root select-container">
          <span>{unCamelCase(label)}</span>
          <Select
            className="select-input"
            value={data[label]}
            onChange={e => {
              setData({ ...data, [label]: e.target.value });
            }}
          >
            <MenuItem value={'black'}>black</MenuItem>
            <MenuItem value={'blue'}>blue</MenuItem>
            <MenuItem value={'bronze'}>bronze</MenuItem>
            <MenuItem value={'crimson'}>crimson</MenuItem>
            <MenuItem value={'cyan'}>cyan</MenuItem>
            <MenuItem value={'dark-green'}>dark-green</MenuItem>
            <MenuItem value={'green'}>green</MenuItem>
            <MenuItem value={'indigo'}>indigo</MenuItem>
            <MenuItem value={'lime'}>lime</MenuItem>
            <MenuItem value={'magenta'}>magenta</MenuItem>
            <MenuItem value={'mint'}>mint</MenuItem>
            <MenuItem value={'navy-blue'}>navy-blue</MenuItem>
            <MenuItem value={'orange'}>orange</MenuItem>
            <MenuItem value={'pink'}>pink</MenuItem>
            <MenuItem value={'purple-classic'}>purple-classic</MenuItem>
            <MenuItem value={'red'}>red</MenuItem>
            <MenuItem value={'salmon'}>salmon</MenuItem>
            <MenuItem value={'scarlet'}>scarlet</MenuItem>
            <MenuItem value={'teal'}>teal</MenuItem>
            <MenuItem value={'yellow'}>yellow</MenuItem>
          </Select>
        </div>
      );
    } else {
      return (
        <div key={label} className="MuiFormControl-root MuiTextField-root select-container">
          <span>{unCamelCase(label)}</span>
          <Select
            className="select-input"
            value={convertBoolean(data[label])}
            onChange={e => {
              setData({ ...data, [label]: e.target.value });
            }}
          >
            <MenuItem value={false}>false</MenuItem>
            <MenuItem value={true}>true</MenuItem>
          </Select>
        </div>
      );
    }
  });
};

export default EditableSelect;
